<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1500px"
        title="Edit Product"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <el-form ref="editForm" :model="editForm" label-width="110px" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="12">
                        <el-col :span="24">
                            <el-form-item
                                label="Product Type"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Please select Product Type',
                                    },
                                ]"
                                prop="type"
                                size="small"
                            >
                                <el-radio-group
                                    v-model="editForm.type"
                                    @change="typeChange"
                                >
                                    <el-radio :label="1">{{
                                        $i18n.locale == "zh" ? "是" : "Single"
                                    }}</el-radio>
                                    <el-radio :label="2">{{
                                        $i18n.locale == "zh"
                                            ? "否"
                                            : "Multi Attribute"
                                    }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Product Name"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Please input Product Name',
                                    },
                                ]"
                                prop="goods_name"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="editForm.goods_name"
                                    placeholder="Please input Product Name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Category"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Please input Category',
                                    },
                                ]"
                                prop="catalog_id"
                                size="small"
                            >
                                <!-- <el-input
                                    clearable
                                    size="small"
                                    v-model="editForm.category"
                                    placeholder="Please input Category"
                                ></el-input> -->
                                <el-cascader
                                    filterable
                                    clearable
                                    :options="treeData"
                                    :props="cascaderProps"
                                    v-model="editForm.catalog_id"
                                    style="width: 100%"
                                    placeholder="Plaese Select Category"
                                    size="small"
                                    :show-all-levels="false"
                                >
                                </el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="SPU"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Please input SPU',
                                    },
                                ]"
                                prop="spu"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    placeholder="Please input SPU"
                                    maxlength="200"
                                    size="small"
                                    v-model="editForm.spu"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Tag" size="small" prop="tags">
                                <tagsInput
                                    :tagsList.sync="editForm.tags"
                                    title="Tag"
                                    :visible="editVisible"
                                ></tagsInput>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Keyword"
                                size="small"
                                prop="keyword"
                            >
                                <tagsInput
                                    :tagsList.sync="editForm.keyword"
                                    title="Keyword"
                                    :visible="editVisible"
                                ></tagsInput>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="New Arrivals"
                                size="small"
                                prop="new_arrival_date"
                            >
                                <el-date-picker
                                    v-model="editForm.new_arrival_date"
                                    type="date"
                                    placeholder="Please select"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Promotion"
                                size="small"
                                :label-width="
                                    $i18n.locale == 'zh' ? '100px' : '110px'
                                "
                                prop="promotion"
                            >
                                <el-checkbox
                                    v-model="editForm.promotion"
                                    :label="1"
                                    :true-label="1"
                                    >Yes</el-checkbox
                                >
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Private Products"
                                size="small"
                                prop="private_user_id"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="editForm.private_user_id"
                                    placeholder="Please input Private Products"
                                ></el-input>
                            </el-form-item>
                        </el-col>

                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Picture"
                            size="small"
                            prop="goods_images"
                        >
                            <imgUpload
                                :images="editForm.goods_images"
                                ref="uploadsRef"
                                @imagesChange="imagesChange"
                                :multiple="true"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Description"
                            size="small"
                            prop="goods_desc"
                        >
                            <vue-tinymce
                                v-model="editForm.goods_desc"
                                :setting="setting"
                                v-if="editVisible"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="table">
                            <el-table
                                border
                                :data="editForm.attributes"
                                ref="attributes"
                                highlight-current-row
                                max-height="500px"
                            >
                                <el-table-column
                                    label="Images"
                                    align="center"
                                    width="80"
                                >
                                    <template slot-scope="scope">
                                        <el-image
                                            style="
                                                width: 60px;
                                                height: 60px;
                                                cursor: pointer;
                                            "
                                            class="elImage_show"
                                            :src="scope.row.images[0]"
                                            fit="contain"
                                            @click.native="updateImgFn(scope)"
                                        >
                                            <div
                                                slot="error"
                                                class="image-slot"
                                            >
                                                <i
                                                    class="
                                                        el-icon-picture-outline
                                                    "
                                                ></i>
                                            </div>
                                            <div
                                                slot="placeholder"
                                                class="image-slot"
                                            >
                                                <i class="el-icon-loading"></i>
                                            </div>
                                        </el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="SKU"
                                    align="center"
                                    width="150"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.sku'
                                            "
                                        >
                                            <el-input
                                                clearable
                                                placeholder="SKU"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.sku"
                                            ></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="CombinationSKU"
                                    align="center"
                                    prop="is_combine_sku"
                                    width="150"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['is_combine_sku'])"
                                        >
                                            Combination SKU
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: false }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.is_combine_sku'
                                            "
                                        >
                                            <el-select
                                                v-model="scope.row.is_combine_sku"
                                                clearable
                                                filterable
                                                size="small"
                                            >
                                                <el-option
                                                    :label="item.label"
                                                    :value="item.value"
                                                    v-for="item of combineList"
                                                    :key="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Weight"
                                    align="center"
                                    prop="weight"
                                    width="140"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['weight'])"
                                        >
                                            Weight
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-input
                                            clearable
                                            placeholder="Weight"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.weight"
                                        >
                                            <template slot="append"
                                                >g</template
                                            >
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="LWH (mm)"
                                    align="center"
                                    prop="lwh"
                                    width="150"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['lwh'])"
                                        >
                                            LWH (mm)
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <lwhPopover
                                            :width="300"
                                            :index="scope.$index"
                                            :row="scope.row"
                                            @handleBlur="handleBlur"
                                            :lwh="[
                                                scope.row.length,
                                                scope.row.width,
                                                scope.row.height,
                                            ]"
                                        >
                                            <el-input
                                                readonly
                                                class="lwh_input"
                                                placeholder="LWH"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.lwh"
                                            >
                                            </el-input>
                                        </lwhPopover>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Price"
                                    align="center"
                                    prop="price"
                                    width="140"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['price'])"
                                        >
                                            Price
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <!-- <el-input
                                            placeholder="Price"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.price"
                                        >
                                            <template slot="prepend"
                                                >$</template
                                            >
                                        </el-input> -->
                                        <pricePopover
                                            :width="300"
                                            :index="scope.$index"
                                            :row="scope.row"
                                            title="Price"
                                            :handleBlur="handlePriceBlur"
                                            :price="scope.row.price"
                                            :mspr="scope.row.mspr"
                                        >
                                            <el-input
                                                placeholder="Value"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.price"
                                            >
                                                <template slot="prepend">$</template >
                                            </el-input>
                                        </pricePopover>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Stock "
                                    align="center"
                                    prop="stock"
                                    width="120"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['stock'])"
                                        >
                                            Stock
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Stock"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.stock"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column
                                    label="Delivery Time"
                                    align="center"
                                    prop="value"
                                    width="130"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Please input Delivery Time"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.delivery_time"
                                        ></el-input>
                                    </template>
                                </el-table-column> -->
                                <el-table-column
                                    label="Tags"
                                    align="center"
                                    prop="tags"
                                    width="180"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['tags'])"
                                        >
                                            Tags
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-cascader
                                            popper-class="tags_cascader"
                                            filterable
                                            clearable
                                            :options="goodsTagList"
                                            :props="tagsCascaderProps"
                                            v-model="scope.row.tags"
                                            style="width: 100%"
                                            placeholder="Plaese Select Tags"
                                            size="small"
                                            :show-all-levels="false"
                                        >
                                        </el-cascader>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Value"
                                    align="center"
                                    prop="value"
                                    width="120"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['value'])"
                                        >
                                            Value
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <inputPopover
                                            :width="300"
                                            :index="scope.$index"
                                            :row="scope.row"
                                            title="Value"
                                            :handleBlur="handleInputBlur"
                                            :value="scope.row.value"
                                        >
                                            <el-input
                                                placeholder="Value"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.value"
                                            >
                                            </el-input>
                                        </inputPopover>
                                        <!-- <el-input
                                            placeholder="Value"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.value"
                                        ></el-input> -->
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Type"
                                    align="center"
                                    prop="delivery_type"
                                    width="120"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['delivery_type'])"
                                        >
                                            Type
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: false }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.delivery_type'
                                            "
                                        >
                                            <el-select
                                                v-model="scope.row.delivery_type"
                                                clearable
                                                filterable
                                                size="small"
                                            >
                                                <el-option
                                                    :label="item.label"
                                                    :value="item.value"
                                                    v-for="item of deliveryType"
                                                    :key="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="ProcessingTime"
                                    align="center"
                                    prop="processing_time"
                                    width="150"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['processing_time'])"
                                        >
                                            ProcessingTime
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: false }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.processing_time'
                                            "
                                        >
                                            <el-select
                                                v-model="scope.row.processing_time"
                                                clearable
                                                filterable
                                                size="small"
                                            >
                                                <el-option
                                                    :label="item.label"
                                                    :value="item.value"
                                                    v-for="item of processingList"
                                                    :key="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column
                                    label="Customized"
                                    align="center"
                                    prop="value"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            effect="dark"
                                            :content="
                                                scope.row.metafields_label
                                            "
                                            :disabled="
                                                !Boolean(
                                                    scope.row.metafields_label
                                                )
                                            "
                                            placement="top"
                                        >
                                            <el-input
                                                readonly
                                                placeholder="Please input Customized`"
                                                maxlength="100"
                                                size="small"
                                                v-model="
                                                    scope.row.metafields_label
                                                "
                                                @click.native="
                                                    customizedShowDialog(
                                                        scope.$index
                                                    )
                                                "
                                            ></el-input>
                                        </el-tooltip>
                                    </template>
                                </el-table-column> -->
                                <el-table-column
                                    label="Status"
                                    align="center"
                                    prop="status"
                                    width="150"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            class="
                                                el-icon-magic-stick
                                                magic-btn
                                            "
                                            @click="magic(scope, ['status'])"
                                        >
                                            Status
                                        </el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.status'
                                            "
                                        >
                                            <el-select
                                                v-model="scope.row.status"
                                                filterable
                                                size="small"
                                            >
                                                <el-option
                                                    label="On sale"
                                                    :value="10"
                                                    >On sale</el-option
                                                >
                                                <el-option
                                                    label="Off"
                                                    :value="60"
                                                    >Off</el-option
                                                >
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    :key="item"
                                    width="130"
                                >
                                    <template slot="header" slot-scope="scope">
                                        Operation
                                        <el-button
                                            v-show="editForm.type == 2"
                                            type="text"
                                            icon="el-icon-plus"
                                            @click="addItem(scope)"
                                        ></el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            icon="el-icon-minus"
                                            style="color: red"
                                            @click="removeItem(scope)"
                                        ></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false">
                Close
            </el-button>
        </span>
        <updateImg
            :updateImgVisible.sync="updateImgVisible"
            :tableItemIndex.sync="tableItemIndex"
            :imagesList="imagesList"
            :goodsImages="editForm.goods_images"
            accept=".jpg"
            @imgUrl="imgUrl"
        ></updateImg>
        <customized
            :customizedVisible.sync="customizedVisible"
            :customizedList="customizedList"
            @saveMetafiled="saveMetafiled"
        ></customized>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
import tagsInput from "@/common/components/tags-input";
import lwhPopover from "@/common/components/table/lwhPopover.vue";
import inputPopover from "@/common/components/table/inputPopover.vue";
import pricePopover from "@/common/components/table/pricePopover.vue";
import imgUpload from "@/common/components/imgUpload";
import updateImg from "./updateImg";
import customized from "./customized.vue";
export default {
    data() {
        return {
            oldAttribute: [],
            editForm: {
                type: 1,
                goods_name: "", //产品名称
                catalog_id: [],
                category: "", // 产品分类
                spu: "",
                tags: [], // 标签
                keyword: [], // 关键字
                new_arrival_date: "",
                promotion: "",
                private_user_id: "",
                goods_images: [], // 刊登图片
                goods_desc: "", // 产品描述
                attributes: [
                    {
                        images: [], // 产品图片
                        sku: "", //属性sku
                        weight: "",
                        length: "",
                        height: "",
                        width: "",
                        lwh: "",
                        price: 0.00, // 价格
                        mspr: 0.00,
                        stock: "", // 库存
                        delivery_time: "",
                        metafields: "",
                        status: 10,
                        delivery_type: 1,
                        processing_time:'',
                        value: ''
                    },
                ],
            },
            imagesList: [],
            goodsImages:[],
            updateImgVisible: false,
            tableItemIndex: "",
            emptyTableItem: {
                images: [], // 产品图片
                sku: "", //属性sku
                weight: "",
                length: "",
                height: "",
                width: "",
                lwh: "",
                price: 0.00, // 价格
                mspr: 0.00,
                stock: "", // 库存
                delivery_time: "",
                metafields: "",
                status: 10,
                delivery_type: 1,
                processing_time:'',
                value: ''
            },
            shopList: [],
            loading: false,
            customizedVisible: false,
            deliveryType: [
                /* {
                    label: "",
                    value: 0,
                }, */
                {
                    label: "自营定制",
                    value: 1,
                },
                {
                    label: "外包",
                    value: 2,
                },
                {
                    label: "代销标品",
                    value: 3,
                },
                {
                    label: "OEM",
                    value: 4,
                },
                {
                    label: "自营标品",
                    value: 5,
                },
                {
                    label: "代销定制",
                    value: 6,
                },
            ],
            processingList:[
                {
                    label: "1-3 days",
                    value: 1,
                },
                {
                    label: "3-5 days",
                    value: 2,
                },
                {
                    label: "5-7 days",
                    value: 3,
                },
                {
                    label: "More than 7 days",
                    value: 4,
                },
            ],
            combineList:[
                {
                    label: "Yes",
                    value: 1,
                },
                {
                    label: "No",
                    value: 2,
                },
            ],
        };
    },
    methods: {
        imagesChange(images) {
            this.editForm.goods_images = images;
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    // return
                    cmofferApi
                        .productsSetList(
                            {
                                ...this.editForm,
                                goods_id: this.editForm.id,
                                // catalog_id: this.editForm.catalog_id.toString(),
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            this.loading = false;
                            if (res && res.errcode === 0) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
        closeDialog() {
            this.editForm = {
                type: 1,
                goods_name: "", //产品名称
                catalog_id: [],
                category: "", // 产品分类
                spu: "",
                tags: [], // 标签
                keyword: [], // 关键字
                new_arrival_date: "",
                promotion: "",
                private_user_id: "",
                goods_images: [], // 刊登图片
                goods_desc: "", // 产品描述
                attributes: [
                    {
                        images: [], // 产品图片
                        sku: "", //属性sku
                        weight: "", //属性名称
                        lwh: "",
                        price: 0.00, // 价格
                        mspr: 0.00,
                        stock: "", // 库存
                        delivery_time: "",
                        metafields: "",
                        status: 10,
                        delivery_type: 1,
                        processing_time:'',
                        value: ''
                    },
                ],
            };
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        updateImgFn(scope) {
            this.imagesList = scope.row.images;
            this.updateImgVisible = true;
            this.tableItemIndex = scope.$index;
        },
        imgUrl(params) {
            this.editForm.attributes[this.tableItemIndex].images = params;
        },
        removeItem(scope) {
            if (this.editForm.attributes.length > 1) {
                for (let i in this.editForm.attributes) {
                    if (i == scope.$index) {
                        this.editForm.attributes.splice(i, 1);
                    }
                }
            } else {
                return false;
            }
        },
        typeChange(val) {
            if (val == 1 && this.editForm.attributes.length > 1) {
                this.oldAttribute = JSON.parse(
                    JSON.stringify(this.editForm.attributes)
                );
                this.editForm.attributes.splice(
                    1,
                    this.editForm.attributes.length - 1
                );
            } else if (val == 2 && this.oldAttribute.length > 1) {
                for (let i = 1; i < this.oldAttribute.length; i++) {
                    this.editForm.attributes.push(this.oldAttribute[i]);
                }
            }
        },
        productsSetList() {
            cmofferApi
                .productsSetList({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.editForm = {
                            ...res.data,
                            platform_id: "",
                            shop_id: "",
                            listing_status: "draft",
                            goods_images: res.data.goods_images || [], // 刊登图片
                            sku: res.data.spu,
                            category:
                                res.data.goods_category &&
                                res.data.goods_category.name_en,
                            catalog_id: res.data.catalog,
                            /* .split(",")
                                .map((item) => {
                                    return (item = Number(item));
                                }) ,*/
                            attributes: res.data.goods_attribute,
                        };
                        this.editForm.attributes.map((item) => {
                            if (item.metafields) {
                                let metafields = JSON.parse(
                                    JSON.stringify(item.metafields)
                                );
                                this.$set(
                                    item,
                                    "metafields_label",
                                    item.metafields
                                        .map((sItem) => sItem.key)
                                        .join(",")
                                );
                                item.metafields = metafields
                                    .map((sItem) => sItem.id)
                                    .join(",");
                            }
                            this.$set(
                                item,
                                "lwh",
                                `${item.length}${item.width ? " x " : ""}${
                                    item.width
                                }${item.height ? " x " : ""}${item.height}`
                            );
                            // 处理发货类型默认值
                            item.delivery_type == 0 && (item.delivery_type = "");
                        });
                        this.loading = false;
                    }
                });
        },
        shopSelect() {
            cmofferApi
                .shopSelect({ platform_id: this.platform_id }, "get")
                .then((res) => {
                    if (res) {
                        this.shopList = res.data;
                    }
                });
        },
        handleBlur(data) {
            let { length, width, height } = data.lwh;
            this.editForm.attributes[data.index].lwh = `${length}${
                width ? " x " : ""
            }${width}${height ? " x " : ""}${height}`;
            this.editForm.attributes[data.index].length = length;
            this.editForm.attributes[data.index].width = width;
            this.editForm.attributes[data.index].height = height;
        },
        handleInputBlur(value, index) {
            this.editForm.attributes[index].value = value
        },
        handlePriceBlur(type, value, index) {
            this.editForm.attributes[index][type] = value
        },
        addItem(row) {
            this.emptyTableItem = {
                images: [], // 产品图片
                sku: "", //属性sku
                weight: "",
                length: "",
                height: "",
                width: "",
                lwh: "",
                price: 0.00, // 价格
                mspr: 0.00,
                stock: "", // 库存
                delivery_time: "",
                metafields: "",
                status: 10,
                delivery_type: 1,
                processing_time:'',
                value: ''
            };
            let dataTemplate = JSON.parse(JSON.stringify(this.emptyTableItem));
            if (this.editForm.attributes.length == 0 || row) {
                this.editForm.attributes.push(dataTemplate);
            }
        },
        customizedShowDialog(i) {
            this.customizedVisible = true;
            this.customizedList = this.editForm.attributes[i].metafields_label;
            this.tableItemIndex = i;
        },
        saveMetafiled(data) {
            this.editForm.attributes[this.tableItemIndex].metafields = data
                .map((item) => item.id)
                .join(",");
            this.editForm.attributes[this.tableItemIndex].metafields_label =
                data.map((item) => item.key).join(",");
        },
        magic(scope, key) {
            if (key instanceof Array) {
                for (let i = 0; i < key.length; i++) {
                    this.magic(scope, key[i]);
                }
                return;
            }
            /* if (key == "gross_weight" || key == "net_weight") {
                if (this.editForm.attributes[0][key] == 0) {
                    return false;
                }
            } */
            let value = this.editForm.attributes[0][key];
            for (let i in this.editForm.attributes) {
                this.$set(this.editForm.attributes[i], key, value);
            }
        },
    },
    components: {
        lwhPopover,
        inputPopover,
        pricePopover,
        imgUpload,
        updateImg,
        tagsInput,
        customized,
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        platform_id: Number,
        funcName: String,
        treeData: Array,
        goodsTagList: Array,
        cascaderProps: {
            type: () => Object,
            default: {
                value: "id",
                label: "name_en",
                children: "cat_id",
                checkStrictly: true,
                multiple: true,
            },
        },
        tagsCascaderProps: {
            type: () => Object,
            default: {
                value: "id",
                label: "name",
                children: "child",
                checkStrictly: true,
                multiple: true,
            },
        },
    },
    computed: {
        ...mapState({
            setting: (state) =>
                Object.assign(JSON.parse(JSON.stringify(state.index.setting)), {
                    height: 400,
                }),
        }),
    },
    watch: {
        editVisible() {
            if (this.editVisible) {
                // this.loading = true;
                // this.shopSelect();
                this.productsSetList();
            }
        },
        editForm: {
            handler(val) {
                console.log(val);
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.edit {
    .container {
        width: 100%;
        .el-upload--picture-card {
            float: left !important;
            margin-right: 10px;
        }
        .uploadBox {
            .el-upload,
            .el-upload--text {
                width: 100%;
                height: 100%;
            }
        }
        .describeContent {
            line-height: 1.6;
        }
        .addAttribute {
            color: $color-primary;
            text-align: left;
        }

        .el-checkbox__label {
            font-size: 12px;
        }
        .table {
            .el-form-item {
                margin: 0;
            }
            .el-input-group__prepend {
                padding: 0 10px;
                & + .el-input__inner {
                    padding-right: 10px;
                }
            }
            .lwh_input {
                .el-input__inner {
                    padding: 0 5px 0 10px;
                }
            }
        }
    }
    .el-select--small {
        width: 100%;
    }
}
</style>
